import lang from '../../lib/language';

import documentsLogo from '../../assets/img/icon-documents.png';
import logoutLogo from '../../assets/img/icon-logout.png';
import tradesLogo from '../../assets/img/icon-orders-trades.png';
import personalDetailsLogo from '../../assets/img/icon-personal-details.png';
import securityLogo from '../../assets/img/icon-security.png';
import { UI_ROUTES } from '../../util/routes';

import { myProfileIds } from './MyProfile.constants';
import { MyProfileItem } from './MyProfile.types';

export const getMenuList = (): MyProfileItem[] => {
  const menuList: MyProfileItem[] = [];
  menuList.push({
    id: myProfileIds.personalDetails,
    label: lang.myProfilePersonalDetails(),
    path: UI_ROUTES.myAccountPersonalDetails,
    img: personalDetailsLogo,
  });

  menuList.push({
    id: myProfileIds.tradingHistory,
    label: lang.commonTradeHistoryTitle(),
    path: UI_ROUTES.tradeHistory,
    img: tradesLogo,
  });

  menuList.push({
    id: myProfileIds.security,
    label: lang.mobileProfileChangePassword(),
    img: securityLogo,
  });

  menuList.push({
    id: myProfileIds.logout,
    label: lang.myProfileLogout(),
    path: '',
    img: logoutLogo,
  });

  return menuList;
};
